import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { subscribePush, unsubscribePush, testPush, getPushPermissionState, isStandalone } from "@/lib/pwa";
import { toast } from "sonner";

export default function PWABanner() {
  const [perm, setPerm] = useState("default");
  const [installPrompt, setInstallPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [done, setDone] = useState(() => localStorage.getItem("mj_pwa_done") === "1");

  useEffect(() => {
    getPushPermissionState().then(setPerm);
    setInstalled(isStandalone());
    const handler = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };
    const onInstalled = () => {
      localStorage.setItem("mj_pwa_done", "1");
      setDone(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const ativar = async () => {
    try {
      await subscribePush();
      setPerm("granted");
      toast.success("Notificações ativadas!");
    } catch (e) {
      toast.error(e.message || "Falha ao ativar");
    }
  };

  const desativar = async () => {
    try {
      await unsubscribePush();
      setPerm("default");
      toast.success("Notificações desativadas");
    } catch (e) { toast.error(e.message); }
  };

  const instalar = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === "accepted") {
      toast.success("App instalado!");
      setInstallPrompt(null);
    }
  };

  // Nada para mostrar — configuração concluída ou banner ocultado pelo usuário
  if (done) return null;
  if (installed && perm === "granted") return null;
  if (perm === "granted" && !installPrompt) return null; // notificações ativas e sem instalação pendente
  if (perm === "unsupported" && !installPrompt) return null;

  return (
    <div className="border-2 border-[#142766] bg-[#142766]/5 p-4 flex flex-wrap items-center justify-between gap-3" data-testid="pwa-banner">
      <div className="flex-1 min-w-[200px]">
        <div className="label-cap brand-text">App PIM</div>
        <div className="text-sm font-medium mt-1">
          {!installed && installPrompt && "Instale o PIM no seu celular para acesso rápido"}
          {(installed || !installPrompt) && perm !== "granted" && "Ative notificações para receber ofertas em tempo real"}
        </div>
      </div>
      <div className="flex gap-2">
        {installPrompt && !installed && (
          <Button onClick={instalar} className="btn-sharp brand-bg text-white" size="sm" data-testid="pwa-install">
            Instalar
          </Button>
        )}
        {perm !== "granted" && perm !== "unsupported" && (
          <Button onClick={ativar} variant="outline" className="btn-sharp brand-border brand-text" size="sm" data-testid="pwa-notif-ativar">
            Ativar notificações
          </Button>
        )}
        {perm === "granted" && (
          <>
            <Button onClick={() => testPush().then(() => toast.success("Push de teste enviado"))}
              variant="outline" className="btn-sharp" size="sm" data-testid="pwa-test">
              Testar
            </Button>
            <Button onClick={desativar} variant="ghost" size="sm" className="text-xs" data-testid="pwa-notif-desativar">
              Desativar
            </Button>
          </>
        )}
        <Button onClick={() => { localStorage.setItem("mj_pwa_done", "1"); setDone(true); }}
          variant="ghost" size="sm" className="text-xs" data-testid="pwa-ocultar">
          Ocultar
        </Button>
      </div>
    </div>
  );
}
